import QRCode from "qrcode.react";

import { CaseState } from "app/reducers/caseReducer";
import { truncatePatientName } from "util/patientUtils";

const BottleBarcode = ({
  id,
  printCase,
}: {
  id: Number;
  printCase: CaseState;
}) => {
  const specimen = printCase?.specimens.find((s) => s.id === id);
  const patientName = truncatePatientName(printCase?.patient);

  return specimen ? (
    <div className={`DecoratedBarcode DecoratedBarcode--bottle`}>
      <div className="Barcode BottleBarcode">
        <div className="Barcode__label">
          <p className="Barcode__subtitle">
            <code>{printCase?.accession}</code>
          </p>
          <p className="Barcode__patient">{patientName}</p>
        </div>
        <p className="Barcode__title">{specimen.name}</p>
        <div className="Barcode__qr">
          <QRCode
            value={`specimen-${specimen.id}`}
            size={36}
            bgColor={"#ffffff"}
            fgColor={"var(--black)"}
            level={"Q"}
            includeMargin={false}
            renderAs={"svg"}
          />
        </div>
      </div>
    </div>
  ) : null;
};

export default BottleBarcode;
